<template>
  <v-list-item
    :key="notification_id"
  >
    <v-list-item-content>
      <v-list-item-title v-text="title" />
      <v-list-item-subtitle style="white-space: initial;">
        {{ displayBody }}

        <v-row>
          <v-btn
            v-if="!read_at"
            color="primary"
            text
            dense
            small
            plain
            @click="$emit('ack-one')"
          >
            Mark as read
          </v-btn>

          <template
            v-if="isOverExcerptLength"
          >
            <br />
            <v-btn
              v-if="isOverExcerptLength"
              class="pl-0"
              color="primary"
              text
              dense
              small
              plain
              @click="isFullyRevealed = !isFullyRevealed"
            >
              {{ isFullyRevealed ? 'Collapse' : 'Show More' }}
            </v-btn>
          </template>

        </v-row>
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-list-item-action-text v-text="fmtCreated(created)" />
      <v-icon
        v-if="!read_at"
        color="primary"
      >
        mdi-bell
      </v-icon>
      <v-icon
        v-if="isNew"
        class="mt-1"
        color="primary"
      >
        mdi-new-box
      </v-icon>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import moment from 'moment'

const EXCERPT_LENGTH = 200

export default {
  props: {
    notification_id: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    body: {
      type: String,
      required: true,
    },
    isNew: {
      type: Boolean,
      required: true,
    },
    read_at: {
      type: [String, null],
    },
    created: {
      type: String,
      required: true,
    },
  },

  emits: ['ack-one'],

  data() {
    return {
      isFullyRevealed: false,
      EXCERPT_LENGTH,
    }
  },

  computed: {
    isOverExcerptLength() {
      return this.body.length > EXCERPT_LENGTH
    },
    displayBody() {
      if (!this.isOverExcerptLength || this.isFullyRevealed) {
        return this.body
      }

      return this.body.slice(0, EXCERPT_LENGTH) + '...'
    },
  },

  methods: {
    fmtCreated(created) {
      return moment.utc(created).from(moment())
    },
  }
}
</script>
